import { render, staticRenderFns } from "./active-checkbox-field.component.vue?vue&type=template&id=c93d2bdc&scoped=true&"
import script from "./active-checkbox-field.component.vue?vue&type=script&lang=ts&"
export * from "./active-checkbox-field.component.vue?vue&type=script&lang=ts&"
import style0 from "./active-checkbox-field.component.vue?vue&type=style&index=0&id=c93d2bdc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93d2bdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
